const mediaFormats = {
  image: { extensions: ['jpg', 'jpeg', 'png', 'gif', 'webp'], maxSize: 5 },
  audio: { extensions: ['mp3', 'wav'], maxSize: 10 },
  video: { extensions: ['mp4', 'webm', 'mov'], maxSize: 50 }
};

export const validateSelectedMedia = async (file, type, maxSizeOverride) => {
  const format = mediaFormats[type];
  if (!format) return 'Unsupported media type';
  const extension = file.name.split('.').pop().toLowerCase();
  const maxSize = maxSizeOverride ?? format.maxSize;
  if (!format.extensions.includes(extension) || file.size === 0 || file.size > maxSize * 1024 * 1024) {
    return `Invalid ${type} file. Use ${format.extensions.join(', ').toUpperCase()} under ${maxSize}MB.`;
  }

  const url = URL.createObjectURL(file);
  try {
    return await new Promise((resolve) => {
      const element = type === 'image' ? new Image() : document.createElement(type);
      const timer = window.setTimeout(() => finish(`Invalid ${type} file. Choose a playable ${type} file.`), 10000);
      const finish = (error) => {
        window.clearTimeout(timer);
        element.onload = null;
        element.onloadedmetadata = null;
        element.onerror = null;
        if (type !== 'image') element.removeAttribute('src');
        resolve(error);
      };
      element.onerror = () => finish(`Invalid ${type} file. Choose a playable ${type} file.`);
      if (type === 'image') element.onload = () => finish(null);
      else element.onloadedmetadata = () => finish(type === 'video' && !element.videoWidth ? 'Invalid video file. Choose a playable video file.' : null);
      element.src = url;
    });
  } finally {
    URL.revokeObjectURL(url);
  }
};
